import { Pipe, PipeTransform } from '@angular/core';
import { BaseListNumber } from '../utils/number-util';

@Pipe({ name: 'listNumber' })
export class ListNumberPipe implements PipeTransform {
  transform(value: BaseListNumber | number): string {
    return value.toString();
  }
}
